var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"css-curriculumHead"},[_c('b-container',{attrs:{"align":"center"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","align":"center"}},[_c('h2',[_vm._v("내게 맞는 커리큘럼 찾기")]),_c('p',[_vm._v("코더스하이가 제공하는 교육과정을 소개합니다")])])],1),_c('b-row',[_c('b-col',[_c('b-button',{attrs:{"variant":"outline-light","to":{
            name: 'curriculumshow',
            params: { id: 0 }
          },"pill":""}},[_vm._v("iOS 앱 디자인과 앱 개발과정")])],1),_c('b-col',[_c('b-button',{attrs:{"variant":"outline-light","to":{
            name: 'curriculumshow',
            params: { id: 1 }
          },"pill":""}},[_vm._v("코딩 배우기")])],1),_c('b-col',[_c('b-button',{attrs:{"variant":"outline-light","to":{
            name: 'curriculumshow',
            params: { id: 2 }
          },"pill":""}},[_vm._v("App 기획자/UX 디자인 과정")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }